<form [formGroup]="findForm" *ngIf="!hasAccounts">
  <p class="text-muted m-b-16">{{ 'ABHA.FIND_DESCRIPTION' | translate }}</p>

  <div class="m-b-16" *ngIf="!isOtpSent">
    <mat-radio-group formControlName="findBy" (change)="onFindByChange()">
      <mat-radio-button value="mobile" class="m-r-16">{{ 'ABHA.FIND_BY_MOBILE' | translate }}</mat-radio-button>
      <mat-radio-button value="aadhaar">{{ 'ABHA.FIND_BY_AADHAAR' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ (findBy === 'aadhaar' ? 'ABHA.AADHAAR_LABEL' : 'ABHA.MOBILE_LABEL') | translate }}</mat-label>
    <input matInput formControlName="value" inputmode="numeric" [readonly]="isOtpSent"
      [attr.maxlength]="findBy === 'aadhaar' ? 12 : 10" />
    <mat-error *ngIf="findForm.get('value')?.invalid">
      {{ (findBy === 'aadhaar' ? 'ABHA.AADHAAR_PATTERN' : 'ABHA.FIND_MOBILE_INVALID') | translate }}
    </mat-error>
  </mat-form-field>

  <div class="abha-find-not-found" *ngIf="notFoundMessage">
    <p>{{ notFoundMessage }}</p>
    <button mat-flat-button color="primary" type="button" (click)="onCreate()">
      {{ 'ABHA.FIND_CREATE' | translate }}
    </button>
  </div>

  <ng-container *ngIf="isOtpSent">
    <p class="abha-find-notice" *ngIf="otpNotice">{{ otpNotice }}</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'ABHA.OTP_LABEL' | translate }}</mat-label>
      <input matInput formControlName="otp" maxlength="6" inputmode="numeric"
        [placeholder]="'ABHA.OTP_PLACEHOLDER' | translate" />
      <mat-error *ngIf="findForm.get('otp')?.hasError('required')">
        {{ 'ABHA.OTP_REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="findForm.get('otp')?.hasError('pattern')">
        {{ 'ABHA.OTP_PATTERN' | translate }}
      </mat-error>
    </mat-form-field>
    <app-abha-otp-resend [isBusy]="isBusy" (resend)="onSendOtp()"></app-abha-otp-resend>
  </ng-container>

</form>

<section *ngIf="hasAccounts" [attr.aria-label]="'ABHA.FIND_ACCOUNTS_TITLE' | translate">
  <p class="abha-find-title">{{ 'ABHA.FIND_ACCOUNTS_TITLE' | translate }}</p>
  <div class="abha-find-account" *ngFor="let account of accounts">
    <img *ngIf="account.profilePhoto" class="abha-find-photo" [src]="photoSource(account)" [alt]="account.name" />
    <div class="abha-find-details">
      <strong>{{ account.name }}</strong>
      <span>{{ account.abhaNumber }}</span>
      <span class="text-muted">{{ account.abhaAddress }}</span>
      <span class="abha-already-linked" *ngIf="account.linkedPatientNumber">
        {{ 'ABHA.ALREADY_LINKED' | translate: { patientNumber: account.linkedPatientNumber } }}
      </span>
    </div>
    <button mat-flat-button color="primary" type="button" [disabled]="isBusy || !!account.linkedPatientNumber" (click)="onSelect(account)">
      {{ 'ABHA.FIND_SELECT' | translate }}
    </button>
  </div>
</section>
